import { useMutation } from "@tanstack/react-query";
import { baseURL } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type ImportHierarchyResponse = ResponseType<{
  portfoliosCreated: number;
  programsCreated: number;
  projectsCreatedOrUpdated: number;
}>;

function useHierarchyImportMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<ImportHierarchyResponse>["response"],
    AxiosResponseAndError<ImportHierarchyResponse>["error"],
    FormData
  >({
    mutationFn: (data) =>
      ApiRequest.post<ImportHierarchyResponse>(
        `${baseURL}/api/wbs-import/hierarchy`,
        data
      ),
  });

  return mutation;
}

export default useHierarchyImportMutation;
